import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Trucktable.html?raw';
import dojoDate from 'dojo/date';



import { TiInterfaces } from "../TiTypes";
import ResourcePicker from '../../../moreCore/UI/ResourcePicker/ResourcePicker';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import AssignmentItemEditor from './AssignmentItemEditor';
import { TranslationHelpers } from "../../../more/Helpers";
 

class TiTrucktable extends compose(_WidgetBaseSP) {

    templateString: any = template;

    startDay: Date = new Date();
    steps: number = 7;

    trucks: Array<TiInterfaces.TiTruck>;

    currentDndItem: ResourcePicker.ResourceEntry;
    currentDndNode: HTMLElement;

    terminalID: string;

    private _loadingTimeout: number;

    existingAssignmentItems: Array<{
        entry: {
            AssignmentID: string;
            value: string;
            label: string;
            secondaryLabel: string;
        },
        day: string;
        truckId: string;
    }>;

    registry: {
        [EntityId: string]: {
            truckId: string;
            date: string;
            entry: ResourcePicker.ResourceEntry
            AssignmentID: string;
        }
    } = {};

    public handleNodesDisplayState(resourcePicker: MdsLax<InstanceType<typeof ResourcePicker>>) {
        for (let bookingId in this.registry) {
            resourcePicker.hideItem(bookingId);
        }
    }



    public loadExistingItems(callback: Function) {

        this.StandbyStartWithText(TranslationHelpers.tryTranslate("TiBooking__Label_LoadingTrucktable", true), this.domNode);
        let data = [];

        //Webtool_API_TransportIntermodal__GetAssignmentItems
        var url = window.appRoot + "TransportIntermodal/GetAssignmentItems";

        let start = new Date(this.startDay.getTime());
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);

        let stringData = JSON.stringify({
            "terminalID": this.terminalID,
            "start": this.dateToLocalISOString(start),
            "end": this.dateToLocalISOString(dojoDate.add(start, "day", this.steps + 1))
        });

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onloadExistingItemsResponse, callback),
            lang.hitch(this, this._onloadExistingItemsError),
            false // sync
        );
        
    }

    private _onloadExistingItemsResponse(callback, response) {
        this.StandbyStop();

        this.existingAssignmentItems = response;
        console.log("_onloadExistingItemsResponse", response);

        lang.hitch(this, callback)();
    }

    private _onloadExistingItemsError(error) {
        this.StandbyStop();
    }

    public saveChanges() {

        this.StandbyStart();
        let data = [];

        for (let bookingId in this.registry) {
            let item = {
                "bookingID": bookingId,
                "ressourceID": this.registry[bookingId].truckId,
                "date": this.registry[bookingId].date,
                "ID": this.registry[bookingId].AssignmentID, // existing
                "identification": this.registry[bookingId].entry["identification"],
                "ref_freight_forwarders": this.registry[bookingId].entry["ref_freight_forwarders"]?.ID
            };

            data.push(item);
        }

        var url = window.appRoot + "TransportIntermodal/SaveUnloadingAssignment";


        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onSaveUnloadingAssignmentResponse),
            lang.hitch(this, this._onSaveUnloadingAssignmentError),
            false // sync
        );
        
    }

    private _onSaveUnloadingAssignmentResponse(response) {
        this.StandbyStop();

        this.registry = {}; // cleanup?
        this.loadExistingItems(this.drawTable);

        this.emit("saved");
    }
    private _onSaveUnloadingAssignmentError(error) {
        this.StandbyStop();
    }


    drawTable(): void {

        if (this._loadingTimeout != null) {
            clearTimeout(this._loadingTimeout);
        }

        this._loadingTimeout = setTimeout(lang.hitch(this, this.loadExistingItems, this._drawTable), 400);
        
/*
        if (this.existingAssignmentItems == null) {
            this.loadExistingItems(this._drawTable);
        } else {
            this._drawTable();
        }*/
        
    }

    private _drawTable() {
        this.UiModder.domConstruct.empty(this.domNode);

        let table = this.UiModder.domConstruct.create("table", { style: { width: "100%" } }, this.domNode);

        let thead = this.UiModder.domConstruct.create("thead", {}, table);

        // headline
        let tr = this.UiModder.domConstruct.create("tr", { className: "headrow", style: "width: calc(var(--widthFactor) * 1 * var(--sizeBaseUnit))" }, thead);

        // LKW Headline
        this.UiModder.domConstruct.create("th", { className: "groupHead", innerHTML: "LKW", style: "width: calc(var(--widthFactor) * 1 * var(--sizeBaseUnit))" }, tr);

        // folgespalten = Tage
        //
        for (let x = 0; x < this.steps; x++) {
            let currentDayDate = dojoDate.add(this.startDay, "day", x);
            let txtDate = this.dateTimeToString(currentDayDate, "dd.MM.yyyy");
            let txtWeekday = this.dateTimeToString(currentDayDate, "EEE").substr(0, 2).toUpperCase();

            let content = `<div class="mainContainer"><div class="mainLabel">${txtWeekday}</div><div class="secondaryLabel">${txtDate}</div></div>`;

            this.UiModder.domConstruct.create("th", { className: "groupHead", innerHTML: content, style: "width: calc(var(--widthFactor) * 1 * var(--sizeBaseUnit))" }, tr);
        }

        for (let i = 0; i < this.trucks.length; i++) {
            let truck = this.trucks[i];

            // eine zeile pro truck
            //
            let tr = this.UiModder.domConstruct.create("tr", {
                    /*style: {
                        whiteSpace: "nowrap"
                    }*/
                }, table);

            // 1. spalte = LKW
            this.UiModder.domConstruct.create("td", { innerHTML: truck.identification, style: "width: calc(var(--widthFactor) * 1 * var(--sizeBaseUnit))" }, tr);

            // folgespalten = Tage
            //
            for (let x = 0; x < this.steps; x++) {
                let currentDayDate = dojoDate.add(this.startDay, "day", x);
                let col = this.UiModder.domConstruct.create("td", { className: "truckAssignmentCell", innerHTML: "" }, tr);
                let txtDate = this.dateTimeToString(currentDayDate, "dd.MM.yyyy");

                col.dataset["truck"] = truck.ID;
                col.dataset["day"] = txtDate;
                col.dataset["dummy"] = truck.is_dummy.toString();

                let existingItems = this._getAssignmentItems(truck.ID, txtDate);
                if (existingItems.length > 0) {
                    for (let i = 0; i < existingItems.length; i++) {
                        this._drawAssignmentItem(existingItems[i].entry as ResourcePicker.ResourceEntry, col);
                    }
                }



                on(col, "dragover", lang.hitch(this, this._dragOverTruck, col));
                on(col, "drop", lang.hitch(this, this._onDrop_Col, col));
            }

            console.log("truck", truck);
        }
    }

    /**
     * Entfernt alle dragover-Klassen, fügt die dragover-Klasse auf currentDragoverElement ein, falls Element angegeben wird.
     * @param currentDragoverElement
     */
    private _updateDragoverStyles(currentDragoverElement?: HTMLElement) {
        if (this._updateDragoverStyleTimeoutHandle) clearTimeout(this._updateDragoverStyleTimeoutHandle);
        try {
            let elements = this.domNode.getElementsByClassName("dragover");
            for (let i = 0; i < elements.length; i++) {
                let elem = elements[i];
                this.UiModder.domClass.remove(elem, "dragover");
            }
            if (currentDragoverElement) {
                this.UiModder.domClass.add(currentDragoverElement, "dragover");

                this._updateDragoverStyleTimeoutHandle = setTimeout(lang.hitch(this, this._updateDragoverStyles), 1000);
            }
        } catch (ex) {

        }
    }
    private _updateDragoverStyleTimeoutHandle: any = null;

    private _dragOverTruck(col: HTMLTableColElement, evt: MouseEvent) {
        let targetCell = col;// evt.target;


        let is_dummy = targetCell.dataset["dummy"];
        if (is_dummy == "true" && !this.hasUserRole("TI_BookDummyTrucks")) {
            this._updateDragoverStyles();

            return; // abbruch = kein DnD erlaubt
        } else {
            this._updateDragoverStyles(targetCell);
        }
        evt.preventDefault(); // laut HTML-Definition ist das dragover damit erlaubt
    }

    private _getAssignmentItems(truckId: string, dayDate: string) {

        let bookingsInList = [];
        let resultList = [];

        for (let assignmentId in this.registry) {
            let assignmentItem = this.registry[assignmentId];

            if (assignmentItem.truckId == truckId && assignmentItem.date == dayDate) {
                resultList.push(assignmentItem);
            }

            bookingsInList.push(assignmentId);
        }

        if (resultList.length > 0) {
            return resultList;
        }

        for (let assignmentItem of this.existingAssignmentItems) {

            if (assignmentItem.truckId == truckId && assignmentItem.day == dayDate && bookingsInList.indexOf(assignmentItem.entry.value) == -1) {
                resultList.push(assignmentItem);
            }
        }

        return resultList;
    }

    private _onDragStart_Item(item: ResourcePicker.ResourceEntry, evt: DragEvent) {
        //console.log("_onDragStart_Item", item);

        this.currentDndNode = evt.target as HTMLElement;
        this.currentDndItem = item;
    }

    private _onDragEnd_Item(item: ResourcePicker.ResourceEntry, evt: DragEvent) {
        //console.log("_onDragEnd_Item", item);

        this.currentDndNode = evt.target as HTMLElement;
        this.currentDndItem = item;
    }

    private _onDrop_Col(targetCell: HTMLTableCellElement, evt: DragEvent) {
        evt.preventDefault();

        this._updateDragoverStyles();

        if (!this.currentDndItem || !this.currentDndNode) {
            return;
        }
        

        this.registry[this.currentDndItem.value] = {
            truckId: targetCell.dataset["truck"],
            date: targetCell.dataset["day"],
            entry: this.currentDndItem,
            AssignmentID: this.currentDndItem["AssignmentID"]
        };

        this.emit("isDirty", Object.keys(this.registry).length > 0);

        console.log("_onDrop_Col", targetCell, this.currentDndItem);

        //(evt.target as HTMLElement).appendChild(this.currentDndNode);


        this.UiModder.domConstruct.destroy(this.currentDndNode); // current Node destroy. es wird eine neue am target erzeugt


        this._drawAssignmentItem(this.currentDndItem, targetCell);


        /*// offloading mehrere tage
        //
        if (this.currentDndItem["offloading"] == "2") {
            this._drawAssignmentItem(this.currentDndItem, targetCell);
        }*/
    }

    private _onClick_Item(item: ResourcePicker.ResourceEntry, truckId: string, day: string, evt) {
        let dlg = new GenericDialog();
        let form = new AssignmentItemEditor();
        form.item = item;
        form.on("change", lang.hitch(this, this._onChange__AssigmentItemEditor, truckId, day))

        dlg.show(form.domNode, item.label);

        dlg.enableContentOverflow(true);
        form.startup();
    }

    private _onChange__AssigmentItemEditor(truckId, day, item: ResourcePicker.ResourceEntry) {
        //console.log("_onChange__AssigmentItemEditor", item);
        
        this.registry[item.value] = {
            truckId: truckId,
            date: day,
            entry: item,
            AssignmentID: item["AssignmentID"]
        };

        this.emit("isDirty", Object.keys(this.registry).length > 0);
    }

    private _drawAssignmentItem(dataItem: ResourcePicker.ResourceEntry, targetCell: HTMLElement) {
        let assignmentNode = this.UiModder.domConstruct.create("div", {}, targetCell);

        
        assignmentNode.innerHTML = this._computeAssignmentNode(dataItem.value, dataItem.label, this.stringReplaceAll(dataItem.secondaryLabel, "\r\n", "<br>"));

        if (dataItem.colorBG) {
            this.UiModder.domStyle.set(assignmentNode, "color", dataItem.colorTXT);
            this.UiModder.domStyle.set(assignmentNode, "backgroundColor", dataItem.colorBG);
        }

        const truckId = targetCell.dataset["truck"];
        const day = targetCell.dataset["day"];

        //console.log("_drawAssignmentItem", dataItem);
        //let item = lang.clone(dataItem);
        let item = dataItem;

        on(assignmentNode, "dragstart", lang.hitch(this, this._onDragStart_Item, item));
        on(assignmentNode, "dragend", lang.hitch(this, this._onDragEnd_Item, item));

        on(assignmentNode, "click", lang.hitch(this, this._onClick_Item, item, truckId, day));
    }

    private _computeAssignmentNode(ID: string, label: string, secondaryLabel: string) {

        return `<div draggable="true" class="item selectable" datavalue="${ID}">
<div class="splitContainer">
<div class="tooltipIcon"><i class="fas fa-info" i=""></i>
<div class="tooltiptext">??</div>
</div>
<div class="mainContainer">
<div class="mainLabel">${label}</div><div class="secondaryLabel">${secondaryLabel}</div></div></div><div class="overflowContainer"></div></div>`;
    }


    // --------------------own methods ----------------------------end

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(TiTrucktable);